<template>
  <div
    v-if="modalState"
    class="modal-display"
    @click="toggleModal"
  >
    <div class="image">
      <img :src="img.src" >
      <div class="caption">{{ img.title }}</div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Modal',
  data () {
    return {

    }
  },
  components: {

  },
  mixins: [

  ],
  methods: {
    ...mapActions({
      toggleModal: 'toggleModal'
    })
  },
  computed: {
    ...mapGetters({
      modalState: 'modalState',
      img: 'currModalImage'
    })
  },
  watch: {
    $route: () => {
      this.toggleModal()
    }
  },
  created () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal-display {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(60,60,60, 0.98);
    z-index: 1100;
    width: 100vw;
    height: 100vh;
    display: grid;
    place-items: center;
    .image {
      img {
        display: block;
        max-width: 95vw;
        max-height: 90vh;
      }
    }
    .caption {
      margin-top: 1.0rem;
      color: #fff;

    }

  }
</style>
